@if (showProgressBar()) {
  <div
    class="fixed top-0 left-0 z-101010101010 h-0.5 w-full bg-primary-200"
    role="status"
    aria-live="polite"
    aria-label="Loading content">
    <div class="h-full animate-progress bg-primary-600"></div>
  </div>
}

@if (idpInitiatedLoading()) {
  <div
    class="fixed inset-0 z-2147483647 flex items-center justify-center bg-white/90 backdrop-blur-xs">
    <div class="flex flex-col items-center gap-4">
      <axle-spinner size="xl" />
      <p class="text-h4">Logging you in...</p>
    </div>
  </div>
}

<div class="relative z-2147482000 flex w-full flex-col">
  @if (visibleDowntimeBanner(); as downtimeBanner) {
    <div
      class="flex w-full items-center gap-3 bg-orange-50 px-4 py-2"
      role="status"
      aria-live="polite">
      <i
        class="bi bi-exclamation-triangle-fill text-orange-500"
        aria-hidden="true"></i>
      <p class="min-w-0 flex-1 text-center text-xs font-light">
        {{ downtimeBanner.message }}
      </p>
      <button
        axle-button
        variant="close"
        icon="x-lg"
        aria-label="Dismiss downtime notice"
        (click)="dismissDowntimeBanner(downtimeBanner)"></button>
    </div>
  }

  @if (!hideIntegrationBanner()) {
    @if (zoomIntegrationRevoked()) {
      <div class="flex w-full items-center gap-3 bg-red-600 px-4 py-2">
        <i class="bi bi-info-circle text-white"></i>
        <p class="min-w-0 flex-1 text-center text-xs font-light text-white">
          We've detected a problem with your Zoom integration. Please
          re-integrate your Zoom in
          <button class="font-bold underline" (click)="goToPreferences()">
            settings
          </button>
          to ensure no disruption in link creation.
        </p>
        <button
          axle-button
          variant="close"
          icon="x-lg"
          aria-label="Dismiss banner"
          (click)="hideIntegrationBanner.set(true)"></button>
      </div>
    } @else if (googleIntegrationRevoked() || outlookIntegrationRevoked()) {
      <div class="flex w-full items-center gap-3 bg-red-600 px-4 py-2">
        <i class="bi bi-info-circle text-white"></i>
        <p class="min-w-0 flex-1 text-center text-xs font-light text-white">
          We've detected a problem with your calendar integration. Please
          re-integrate your
          {{ googleIntegrationRevoked() ? 'Google' : 'Outlook' }}
          in
          <button class="font-bold underline" (click)="goToPreferences()">
            settings
          </button>
          to ensure calendar invites send properly.
        </p>
        <button
          axle-button
          variant="close"
          icon="x-lg"
          aria-label="Dismiss banner"
          (click)="hideIntegrationBanner.set(true)"></button>
      </div>
    }
  }
</div>

<router-outlet />

@if (showDevBackendOverride) {
  <axle-dev-backend-override />
}

<!-- Toast Container -->
<div
  class="fixed top-2.5 left-1/2 z-2147482000 flex max-w-162.5 -translate-x-1/2 transform flex-col gap-2 rounded-xl shadow-axleBlue">
  @for (toast of toasts(); track $index) {
    <div
      [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
      [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
      class="flex animate-enter items-center justify-between gap-3.5 rounded-xl border px-4 py-2 shadow-sm"
      [ngClass]="{
        'border-red-900 bg-red-50 text-red-900': toast.type === 'error',
        'border-green-900 bg-green-50 text-green-900': toast.type === 'success',
        'border-blue-900 bg-blue-50 text-blue-900': toast.type === 'info'
      }">
      <div class="flex items-center gap-3.5">
        @if (toast.type === 'success') {
          <i class="bi bi-check-circle text-lg" aria-hidden="true"></i>
        } @else if (toast.type === 'error') {
          <i class="bi bi-x-circle text-lg" aria-hidden="true"></i>
        } @else if (toast.type === 'info') {
          <i class="bi bi-info-circle text-lg" aria-hidden="true"></i>
        }
        <p class="text-sm" [innerHTML]="toast.message"></p>
        @if (toast.action) {
          <button
            type="button"
            class="-ml-1.5 text-sm font-medium underline"
            (click)="handleToastAction($index, toast.action.onClick)">
            {{ toast.action.label }}
          </button>
        }
      </div>
      <div class="flex items-center gap-3.5">
        @if (toast.count > 1) {
          <div
            class="flex h-5 w-5 items-center justify-center rounded-full text-xs font-medium text-white"
            [class]="{
              'bg-blue-600': toast.type === 'info',
              'bg-green-600': toast.type === 'success',
              'bg-red-600': toast.type === 'error'
            }">
            {{ toast.count }}
          </div>
        }

        <button
          type="button"
          (click)="removeToast($index)"
          class="-mx-1.5 -my-1.5 ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg p-1.5"
          aria-label="Close">
          <span class="sr-only">Close</span>
          <i class="bi bi-x text-xl"></i>
        </button>
      </div>
    </div>
  }
</div>
